import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/lib/i18n";
import { ContentProvider } from "@/lib/content";
import { ConfigProvider } from "@/lib/config";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

import Landing from "@/pages/Landing";
import Catalog from "@/pages/Catalog";
import Quiz from "@/pages/Quiz";
import Result from "@/pages/Result";
import MyPage from "@/pages/MyPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import NotFound from "@/pages/NotFound";
import DesignPreview from "@/pages/DesignPreview";
import Compliance from "@/pages/Compliance";
import DataProtection from "@/pages/DataProtection";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import About from "@/pages/About";
import Tokushoho from "@/pages/Tokushoho";
import Legal from "@/pages/Legal";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminResults from "@/pages/admin/AdminResults";
import AdminContent from "@/pages/admin/AdminContent";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminPricing from "@/pages/admin/AdminPricing";
import DataRequest from "@/pages/DataRequest";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <ContentProvider>
          <ConfigProvider>
            <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Admin — outside the public Layout */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="results" element={<AdminResults />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="payments" element={<AdminPayments />} />
                <Route path="pricing" element={<AdminPricing />} />
              </Route>

              {/* Public routes wrapped in shared Layout */}
              <Route
                path="*"
                element={
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Landing />} />
                      <Route path="/catalog" element={<Catalog />} />
                      <Route path="/quiz/:id" element={<Quiz />} />
                      <Route path="/result/:id" element={<Result />} />
                      <Route path="/mypage" element={<MyPage />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/design-preview" element={<DesignPreview />} />
                      <Route path="/compliance" element={<Compliance />} />
                      <Route path="/data-protection" element={<DataProtection />} />
                      <Route path="/terms" element={<Terms />} />
                      <Route path="/privacy" element={<Privacy />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/tokushoho" element={<Tokushoho />} />
                      <Route path="/legal" element={<Legal />} />
                      <Route path="/data-request" element={<DataRequest />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Layout>
                }
              />
            </Routes>
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: { borderRadius: 8, border: "1px solid #3B82F6", background: "#0F1525", color: "#fff" },
              }}
            />
          </BrowserRouter>
            </AuthProvider>
          </ConfigProvider>
        </ContentProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
